module.exports = __webpack_public_path__ + "img/qr_2.c0a64c07.png";